import { ServiceBase } from "../shared";
import { Perspectives, ManageResourceTagDisplayModel } from "../tags/types";
import { ResourceTagModel, UploadTagsReviewResponseModel } from "../tags/import/types";

/** Manages access to CRUD functionality for resource tags. */
export default class ResourceTaggingService extends ServiceBase {

  public async getClientProjectTagInfo(perspective: Perspectives): Promise<ManageResourceTagDisplayModel[]> {
    return await this.makeGet<ManageResourceTagDisplayModel[]>("ResourceTagging/GetClientProjectTags", `perspective=${perspective}`);
  }

  public async getClientProjectGroupTagInfo(): Promise<ManageResourceTagDisplayModel[]> {
    return await this.makeGet<ManageResourceTagDisplayModel[]>("ResourceTagging/GetClientProjectGroupTagsAsync");
  }

  public async createAndApplyProjectTags(projectTagsFile: FormData): Promise<ResourceTagModel[]> {
    if (!projectTagsFile) {
      return null;
    }
    return await this.makePost<ResourceTagModel[]>("ResourceTagging/CreateAndApplyProjectTags", projectTagsFile, undefined, true, false, false);
  }

  public async previewCreateAndApplyProjectTags(projectTagsFile: FormData): Promise<UploadTagsReviewResponseModel> {
    if (!projectTagsFile) {
      return null;
    }
    return await this.makePost<UploadTagsReviewResponseModel>("ResourceTagging/PreviewCreateAndApplyProjectTags", projectTagsFile, undefined, true, false, false);
  }

  public async deleteTags(resourceTagIds: number[]): Promise<void> {
    await this.makePost<void>("ResourceTagging/deleteTagsAsync", resourceTagIds);
  }

  public async downloadTags(): Promise<File> {
    return await this.makeGet<File>("ResourceTagging/DownloadTags");
  }
}